import React, { useState, createContext } from 'react'
import "./setupBoard.scss"

import SetupDetails from '../SetupDetails'

interface ISetupBoard {
    groupData: any
    refreshGroupInformations: () => void
}

export const SetupBoardContext = createContext<any>({});

const SetupBoard: React.FC<ISetupBoard> = ({
    refreshGroupInformations, groupData,
}) => {
    const [selectedComp, setSelectedComp] = useState<number>(0)

    return (
        <SetupBoardContext.Provider
            value={{
                refreshGroupInformations,
                selectedComp, setSelectedComp,
            }}
        >
            <div className={`setup-body-wrapper`}>
                <div className='setup-details'>
                    <SetupDetails selected={selectedComp} groupData={groupData} />
                </div>
            </div>
        </SetupBoardContext.Provider>
    )
}

export default SetupBoard